import {Directive, ElementRef, Renderer2, OnInit, OnDestroy, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Directive({
    selector: '[appFadeInOnScroll]',
    standalone: true, // New in Angular 17, allows the directive to be used without declaring it in a module
})
export class FadeInOnScrollDirective implements OnInit, OnDestroy {
    private observer!: IntersectionObserver;

    constructor(private el: ElementRef, private renderer: Renderer2, @Inject(PLATFORM_ID) private platformId: Object) {}

    ngOnInit() {
        // // Set initial styles
        this.renderer.removeClass(this.el.nativeElement, 'animate-slide-up');
        this.renderer.addClass(this.el.nativeElement, 'animation-slide-down');
        if (isPlatformBrowser(this.platformId)) {
            // Create the IntersectionObserver
            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            this.renderer.addClass(this.el.nativeElement, 'animation-slide-up');
                            this.renderer.removeClass(this.el.nativeElement, 'animation-slide-down');
                        } else {
                            this.renderer.addClass(this.el.nativeElement, 'animation-slide-down');
                            this.renderer.removeClass(this.el.nativeElement, 'animate-slide-up');
                        }
                    });
                },
                {
                    threshold: 0.1, // Adjust as necessary
                }
            );

            // Start observing
            this.observer.observe(this.el.nativeElement);
        }
    }

    ngOnDestroy() {
        // Clean up the observer
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
